import { render, staticRenderFns } from "./PostalCodes.vue?vue&type=template&id=4ccdfbc4&scoped=true"
import script from "./PostalCodes.vue?vue&type=script&lang=js"
export * from "./PostalCodes.vue?vue&type=script&lang=js"
import style0 from "./PostalCodes.vue?vue&type=style&index=0&id=4ccdfbc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccdfbc4",
  null
  
)

export default component.exports